import { CurrenCySelector } from "./modules/CurrencySelector";
import { GraphOfferBook } from "./modules/GraphOfferBook";
import { BuyAndSell } from "./modules/BuyAndSell";
import { Calculator } from './modules/Calculator'
import { PriceStatistics } from './modules/PriceStatistics';
import './utils/jquery-selectors';
import { CurrencyInfo } from './modules/CurrencyInfo';
import { CryptoPrice } from "./modules/CryptoPrice";
import tippy from 'tippy.js';

$(async () => {
  // disable theme scroll to anchor
  window.et_pb_smooth_scroll = () => {}

  tippy('[data-tippy-content]', {
    allowHTML: true
  });

  new CurrenCySelector();
  new CurrencyInfo();
  new GraphOfferBook();
  new BuyAndSell();
  new Calculator();
  new PriceStatistics();
  new CryptoPrice();
})
